export default "__VITE_ASSET__CvPuc_7S__"